var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlatinumLeague(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 51 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4655_315331)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M24.9966 54.1349C38.8018 54.1349 49.9932 43.1096 49.9932 29.5091C49.9932 15.9087 38.8018 4.8833 24.9966 4.8833C11.1914 4.8833 0 15.9087 0 29.5091C0 43.1096 11.1914 54.1349 24.9966 54.1349Z",
    fill: "url(#paint0_radial_4655_315331)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0856 13.0845C25.0856 13.0845 24.1535 10.9932 24.0719 7.46089C23.963 2.8159 25.3102 0.0141602 25.3102 0.0141602C25.3102 0.0141602 20.3435 0.75146 12.4717 8.15127C12.4717 8.15127 14.6625 8.88857 14.7985 10.3565C14.9346 11.8311 13.3494 18.1718 13.3494 18.1718C13.3494 18.1718 18.5065 13.3794 25.0856 13.0778V13.0845Z",
    fill: "url(#paint1_linear_4655_315331)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.194 15.0485C15.194 15.0485 17.0378 9.07635 13.7721 7.92348C13.7721 7.92348 18.106 3.56671 23.3176 2.35352C23.3176 2.35352 22.8209 7.08564 23.9503 12.0993C23.9503 12.0993 19.9566 11.9585 15.1872 15.0485H15.194Z",
    fill: "url(#paint2_linear_4655_315331)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4576 7.77936C14.4576 7.77936 18.3561 3.69069 22.7512 3.04053C22.7512 3.04053 22.7989 8.58368 23.6153 11.8278C23.6153 11.8278 19.1453 11.7005 15.7843 14.3145C15.7843 14.3145 17.1995 9.89742 14.4576 7.77936Z",
    fill: "#0F1120"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7438 6.12407C14.3016 6.80775 17.1115 4.49531 20.4657 3.2352C23.8199 1.98179 24.752 0.353027 24.752 0.353027C24.752 0.353027 20.8399 1.05681 14.7506 6.11737L14.7438 6.12407Z",
    fill: "#A3A4A4"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8065 2.09694C22.7588 2.36505 22.8405 2.2645 23.3031 2.14386C23.7658 2.02321 24.5958 0.562012 24.5958 0.562012C24.5958 0.562012 22.9153 1.44677 22.8065 2.09694Z",
    fill: "#575C5B"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7721 7.92348L14.8947 8.17819C14.8947 8.17819 16.3711 6.04672 19.249 4.60563C22.1337 3.16455 22.7665 3.70747 22.7665 3.70747L23.3176 2.35352C23.3176 2.35352 18.4802 3.07741 13.7721 7.92348Z",
    fill: "#6C6674"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8032 13.0845C25.8032 13.0845 26.7353 10.9932 26.8169 7.46089C26.9258 2.8159 25.5786 0.0141602 25.5786 0.0141602C25.5786 0.0141602 30.5453 0.75146 38.4171 8.15127C38.4171 8.15127 36.2264 8.88857 36.0903 10.3565C35.9542 11.8311 37.5395 18.1718 37.5395 18.1718C37.5395 18.1718 32.3823 13.3794 25.8032 13.0778V13.0845Z",
    fill: "url(#paint3_linear_4655_315331)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6942 15.0485C35.6942 15.0485 33.8504 9.07635 37.1162 7.92348C37.1162 7.92348 32.7822 3.56671 27.5706 2.35352C27.5706 2.35352 28.0673 7.08564 26.9379 12.0993C26.9379 12.0993 30.9316 11.9585 35.701 15.0485H35.6942Z",
    fill: "url(#paint4_linear_4655_315331)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4301 7.77936C36.4301 7.77936 32.5316 3.69069 28.1365 3.04053C28.1365 3.04053 28.0889 8.58368 27.2724 11.8278C27.2724 11.8278 31.7424 11.7005 35.1034 14.3145C35.1034 14.3145 33.6883 9.89742 36.4301 7.77936Z",
    fill: "#0F1120"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1451 6.12407C36.5874 6.80775 33.7775 4.49531 30.4233 3.2352C27.0691 1.98179 26.137 0.353027 26.137 0.353027C26.137 0.353027 30.0491 1.05681 36.1383 6.11737L36.1451 6.12407Z",
    fill: "#A3A4A4"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0747 2.09694C28.1224 2.36505 28.0407 2.2645 27.5781 2.14386C27.1154 2.02321 26.2854 0.562012 26.2854 0.562012C26.2854 0.562012 27.9659 1.44677 28.0747 2.09694Z",
    fill: "#575C5B"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1191 7.92348L35.9965 8.17819C35.9965 8.17819 34.5201 6.04672 31.6422 4.60563C28.7574 3.16455 28.1247 3.70747 28.1247 3.70747L27.5736 2.35352C27.5736 2.35352 32.411 3.07741 37.1191 7.92348Z",
    fill: "#6C6674"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3087 12.5884C14.4773 12.5884 5.69382 21.2416 5.69382 31.9056C5.69382 42.5697 14.4773 51.2296 25.3087 51.2296C36.1401 51.2296 44.9168 42.5764 44.9168 31.9056C44.9168 21.2349 36.1333 12.5884 25.3087 12.5884ZM25.3087 46.9734C16.8586 46.9734 10.0141 40.2304 10.0141 31.9056C10.0141 23.5809 16.8586 16.8446 25.3087 16.8446C33.7589 16.8446 40.5965 23.5876 40.5965 31.9056C40.5965 40.2237 33.7521 46.9734 25.3087 46.9734Z",
    fill: "url(#paint5_linear_4655_315331)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3077 14.5376C15.5649 14.5376 7.67264 22.3128 7.67264 31.9111C7.67264 41.5094 15.5649 49.2845 25.3077 49.2845C35.0505 49.2845 42.9427 41.5094 42.9427 31.9111C42.9427 22.3128 35.0505 14.5376 25.3077 14.5376ZM25.3077 46.9788C16.8576 46.9788 10.0131 40.2359 10.0131 31.9111C10.0131 23.5863 16.8576 16.85 25.3077 16.85C33.7578 16.85 40.5955 23.593 40.5955 31.9111C40.5955 40.2292 33.751 46.9788 25.3077 46.9788Z",
    fill: "url(#paint6_linear_4655_315331)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M7.45479 27.2223C7.45479 27.2223 10.4756 16.4778 22.0758 13.8571L20.5382 4.52686C20.5382 4.52686 16.1431 6.35 11.7479 12.5969C11.7479 12.5969 12.4759 14.1185 11.9928 15.4456C11.5098 16.7727 9.27137 20.8011 7.21667 18.3412L8.91078 22.3025L8.09434 23.8307L5.44092 17.0408C5.44092 17.0408 4.97827 19.0852 5.29804 21.8668C5.37288 22.5438 7.45479 27.2223 7.45479 27.2223Z",
    fill: "url(#paint7_linear_4655_315331)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20848 18.3354L6.90231 19.8033L8.24263 22.3102L8.90259 22.3035L7.20848 18.3354Z",
    fill: "#16171A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M5.19414 20.5444C5.19414 20.5444 5.1261 21.3689 5.1261 22.81C5.1261 23.2657 6.66372 27.2204 6.66372 27.2204H7.44614C7.44614 27.2204 5.16692 21.8984 5.18733 20.5444H5.19414Z",
    fill: "#0F1120"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7406 12.5912C11.7406 12.5912 11.5296 13.7977 11.5296 13.9116C11.5296 14.0256 12.4686 15.165 10.999 17.3099C10.999 17.3099 13.0128 15.5806 11.7406 12.5845V12.5912Z",
    fill: "#0F1120"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4691 18.332C12.4691 18.332 13.1018 16.6228 12.9794 12.7821C12.9794 12.7821 16.1226 7.94277 19.4768 6.34082C19.4768 6.34082 19.8715 12.4403 19.8715 13.3452C19.8715 13.3452 15.279 15.0209 12.4691 18.3387V18.332Z",
    fill: "url(#paint8_linear_4655_315331)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M13.032 16.8458C13.032 16.8458 13.481 14.587 13.4334 12.7839C13.4334 12.7839 16.9372 7.64293 19.2029 6.97266C19.2029 6.97266 19.2913 12.4019 19.2029 12.8912C19.1144 13.3738 16.3453 14.3859 13.032 16.8458Z",
    fill: "url(#paint9_linear_4655_315331)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M5.12835 22.8145C5.12835 22.8145 6.33939 29.973 2.56337 30.9449C2.50894 38.0363 9.39423 42.373 9.39423 42.373C9.39423 42.373 6.37341 37.9693 6.67277 27.2248L5.13515 22.8145H5.12835Z",
    fill: "url(#paint10_linear_4655_315331)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M7.90234 40.3175C7.90234 40.3175 3.61604 37.3549 3.55481 31.5302C3.55481 31.5302 6.02453 29.6803 5.69796 24.9683C5.69796 24.9683 6.48718 27.2807 6.45316 28.2057C6.42595 29.1307 6.58924 35.2033 7.90234 40.3242V40.3175Z",
    fill: "url(#paint11_linear_4655_315331)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24959 39.4536C7.24959 39.4536 3.73891 36.7725 3.82736 31.5243C3.82736 31.5243 5.42621 31.2897 5.97051 26.9731L6.29028 28.0724C6.29028 28.0724 6.38553 35.1907 7.24959 39.4469V39.4536Z",
    fill: "url(#paint12_linear_4655_315331)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M2.55557 30.9384C2.55557 30.9384 4.94365 29.4504 5.28384 26.1191C5.28384 26.1191 5.54237 30.2882 2.55557 30.9384Z",
    fill: "#575C5B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20856 18.3325C7.20856 18.3325 8.24951 19.224 9.31088 18.7883C10.3654 18.3593 11.5017 16.7104 11.5017 16.7104C11.5017 16.7104 10.0185 19.043 8.90267 19.2441C7.78687 19.4452 7.20856 18.3325 7.20856 18.3325Z",
    fill: "#575C5B"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M13.032 12.5883L13.4334 13.3188C13.4334 13.3188 15.3656 10.0881 17.1822 8.68726C18.9919 7.28639 19.2437 7.52769 19.2437 7.52769L19.475 6.34131C19.475 6.34131 17.3591 7.34002 15.6241 9.42456C13.8892 11.5091 13.032 12.5883 13.032 12.5883Z",
    fill: "#6C6674"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M3.55481 31.5947L3.92221 32.3521C3.92221 32.3521 4.15353 31.5813 4.57536 31.2663C4.99718 30.9512 5.82723 30.4887 6.05855 29.3761C6.28988 28.2634 6.09257 26.2593 6.09257 26.2593L5.69796 24.959C5.69796 24.959 5.9701 27.3452 5.12645 29.2957C4.2828 31.2461 3.55481 31.588 3.55481 31.588V31.5947Z",
    fill: "#6C6674"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3453 16.1363C13.3453 16.1363 13.9508 13.5424 15.8218 12.0611C17.6928 10.5798 18.5297 12.3828 18.5705 12.8922C18.6181 13.4016 13.3453 16.1363 13.3453 16.1363Z",
    fill: "#CEFFD3"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M5.96925 37.8922C5.96925 37.8922 4.88067 36.8399 4.86025 35.3451C4.83984 33.8504 5.6903 32.8919 5.96925 32.5635C6.2482 32.2418 7.01701 38.9177 7.01701 38.9177L5.96925 37.8922Z",
    fill: "#CEFFD3"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3742 8.62052C17.8503 8.20495 18.102 9.65274 18.3742 9.82701C18.6463 10.0013 18.5987 8.79479 18.3742 8.62052Z",
    fill: "#E8FFEB"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7893 8.15321C15.5376 8.60229 19.0347 6.59147 19.4769 6.34347C19.9124 6.09547 20.4566 4.78174 20.4566 4.78174C20.4566 4.78174 17.1909 6.10218 15.7893 8.15321Z",
    fill: "#575C5B"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0338 16.8435L12.4691 18.3315C12.4691 18.3315 13.7822 17.1317 14.6735 16.2603C15.5647 15.3823 15.7825 15.2817 15.7825 15.2817C15.7825 15.2817 13.9319 15.9654 13.0338 16.8435Z",
    fill: "#7B7882"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4413 27.2218C43.4413 27.2218 40.4204 16.4773 28.8202 13.8566L30.3578 4.52637C30.3578 4.52637 34.753 6.34951 39.1482 12.5965C39.1482 12.5965 38.4202 14.118 38.9032 15.4451C39.3863 16.7723 41.6247 20.8006 43.6794 18.3407L41.9853 22.302L42.8017 23.8302L45.4551 17.0404C45.4551 17.0404 45.9178 19.0847 45.598 21.8663C45.5232 22.5433 43.4413 27.2218 43.4413 27.2218Z",
    fill: "url(#paint13_linear_4655_315331)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6853 18.335L43.9915 19.8029L42.6579 22.8928L41.9912 22.303L43.6853 18.335Z",
    fill: "#16171A"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M45.699 20.5444C45.699 20.5444 45.7671 21.3689 45.7671 22.81C45.7671 23.2657 44.2294 27.2204 44.2294 27.2204H43.447C43.447 27.2204 45.7262 21.8984 45.7058 20.5444H45.699Z",
    fill: "#0F1120"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1546 12.5907C39.1546 12.5907 39.3656 13.7972 39.3656 13.9111C39.3656 14.0251 38.4267 15.1645 39.8962 17.3094C39.8962 17.3094 37.8824 15.5801 39.1546 12.584V12.5907Z",
    fill: "#0F1120"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4249 18.3325C38.4249 18.3325 37.7922 16.6233 37.9079 12.7826C37.9079 12.7826 34.7646 7.94326 31.4104 6.34131C31.4104 6.34131 31.0158 12.4408 31.0158 13.3457C31.0158 13.3457 35.6082 15.0213 38.4181 18.3392L38.4249 18.3325Z",
    fill: "url(#paint14_linear_4655_315331)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M37.862 16.8458C37.862 16.8458 37.413 14.587 37.4606 12.7839C37.4606 12.7839 33.9567 7.64293 31.6911 6.97266C31.6911 6.97266 31.6027 12.4019 31.6911 12.8912C31.7796 13.3805 34.5487 14.3859 37.862 16.8458Z",
    fill: "url(#paint15_linear_4655_315331)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7671 22.8145C45.7671 22.8145 44.556 29.973 48.3321 30.9449C48.3865 38.0363 41.5012 42.373 41.5012 42.373C41.5012 42.373 44.522 37.9693 44.2226 27.2248L45.7603 22.8145H45.7671Z",
    fill: "url(#paint16_linear_4655_315331)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9924 40.317C42.9924 40.317 47.2787 37.3544 47.3399 31.5297C47.3399 31.5297 44.8702 29.6798 45.1968 24.9678C45.1968 24.9678 44.4075 27.2802 44.4415 28.2052C44.4688 29.1302 44.3055 35.2028 42.9924 40.3237V40.317Z",
    fill: "url(#paint17_linear_4655_315331)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6449 39.4536C43.6449 39.4536 47.1556 36.7725 47.0671 31.5243C47.0671 31.5243 45.4683 31.2897 44.924 26.9731L44.6042 28.0724C44.6042 28.0724 44.509 35.1907 43.6449 39.4469V39.4536Z",
    fill: "url(#paint18_linear_4655_315331)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3411 30.9428C48.3411 30.9428 45.9531 29.4548 45.6129 26.1235C45.6129 26.1235 45.3543 30.2926 48.3411 30.9428Z",
    fill: "#575C5B"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6882 18.3325C43.6882 18.3325 42.6473 19.224 41.5859 18.7883C40.5313 18.3593 39.3951 16.7104 39.3951 16.7104C39.3951 16.7104 40.8783 19.043 41.9941 19.2441C43.1031 19.4452 43.6882 18.3325 43.6882 18.3325Z",
    fill: "#575C5B"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8621 12.5878L37.4606 13.3184C37.4606 13.3184 35.5284 10.0876 33.7118 8.68678C31.8953 7.28591 31.6503 7.5272 31.6503 7.5272L31.419 6.34082C31.419 6.34082 33.5349 7.33953 35.2699 9.42408C37.0048 11.5086 37.8621 12.5878 37.8621 12.5878Z",
    fill: "#6C6674"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M47.34 31.5942L46.9726 32.3516C46.9726 32.3516 46.7413 31.5808 46.3195 31.2658C45.8977 30.9507 45.0676 30.4882 44.8363 29.3756C44.605 28.2629 44.8023 26.2588 44.8023 26.2588L45.1969 24.9585C45.1969 24.9585 44.9247 27.3447 45.7684 29.2952C46.612 31.2457 47.34 31.5875 47.34 31.5875V31.5942Z",
    fill: "#6C6674"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5487 16.1363C37.5487 16.1363 36.9432 13.5424 35.0722 12.0611C33.2012 10.5798 32.3644 12.3828 32.3235 12.8922C32.2759 13.4016 37.5487 16.1363 37.5487 16.1363Z",
    fill: "#CEFFD3"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9235 37.8922C44.9235 37.8922 46.0121 36.8399 46.0325 35.3451C46.0529 33.8504 45.2025 32.8919 44.9235 32.5635C44.6446 32.2418 43.8758 38.9177 43.8758 38.9177L44.9235 37.8922Z",
    fill: "#CEFFD3"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5193 8.62052C33.0432 8.20495 32.7915 9.65274 32.5193 9.82701C32.2472 10.0013 32.2948 8.79479 32.5193 8.62052Z",
    fill: "#E8FFEB"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1058 8.15272C35.3575 8.60181 31.8604 6.59099 31.4182 6.34299C30.9828 6.09498 30.4385 4.78125 30.4385 4.78125C30.4385 4.78125 33.7042 6.10169 35.1058 8.15272Z",
    fill: "#575C5B"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8611 16.8425L38.4258 18.3305C38.4258 18.3305 37.1127 17.1307 36.2214 16.2594C35.3301 15.388 35.1124 15.2808 35.1124 15.2808C35.1124 15.2808 36.963 15.9644 37.8611 16.8425Z",
    fill: "#7B7882"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9035 29.0647C7.9035 29.0647 13.5097 16.8389 25.3072 16.8389C37.1048 16.8389 42.8879 30.5929 42.8879 30.5929C42.8879 30.5929 39.2683 14.5332 25.3072 14.5332C11.3461 14.5332 7.9035 29.0647 7.9035 29.0647Z",
    fill: "#6C6674"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8601 14.5395C24.8601 14.5395 27.2618 13.6748 30.2894 14.2446C33.3171 14.8076 35.8684 17.9981 35.8684 17.9981C35.8684 17.9981 32.1741 14.6601 24.8601 14.5395Z",
    fill: "#575C5B"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8846 45.9234C13.796 45.0722 20.4092 47.1634 25.58 47.1031C30.7507 47.0428 38.8607 43.0278 38.8607 43.0278C38.8607 43.0278 34.1662 48.6514 26.1719 49.2815C18.1844 49.9115 14.8846 45.9234 14.8846 45.9234Z",
    fill: "#5C6160"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M41.858 37.3792C41.2933 37.3591 40.8375 38.5454 41.4294 39.2827C42.0145 40.0133 43.1371 37.4328 41.858 37.3792Z",
    fill: "#0F1120"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2325 38.2977C41.3414 38.921 42.1374 38.7534 42.3483 38.3647C42.566 37.9692 42.3687 37.252 41.7836 37.3861C41.1985 37.5201 41.2257 38.2977 41.2257 38.2977H41.2325Z",
    fill: "#BAA1BE"
  }))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2111 38.8662C41.286 38.4574 41.8575 38.7925 42.1432 38.7389C42.429 38.6853 42.1024 39.4092 41.7554 39.4025C41.4084 39.4025 41.2043 38.8662 41.2043 38.8662H41.2111Z",
    fill: "#5C6160"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1651 45.3721C14.1651 45.3721 15.9272 47.651 20.9143 48.9982C20.9143 48.9982 18.152 46.545 14.1651 45.3721Z",
    fill: "#666A69"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3974 49.9203C25.3974 49.9203 21.5329 49.9069 14.7633 47.6279L16.1376 53.7542C16.1376 53.7542 20.9206 57.0117 25.3974 57.0117C29.8742 57.0117 34.6572 53.7542 34.6572 53.7542L36.0315 47.6279C29.2619 49.9136 25.3974 49.9203 25.3974 49.9203Z",
    fill: "url(#paint19_linear_4655_315331)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7231 49.2754C16.7231 49.2754 23.4996 51.4739 34.2425 49.3424L33.7867 52.6603C33.7867 52.6603 30.4325 56.0116 25.3093 56.0116C20.1862 56.0116 17.2402 53.1094 17.2402 53.1094L16.7163 49.2754H16.7231Z",
    fill: "url(#paint20_linear_4655_315331)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3548 50.1702C17.3548 50.1702 26.3968 51.6448 33.7379 49.9624L33.3433 52.6502C33.3433 52.6502 30.4178 55.2307 25.4783 55.4989C20.7974 55.7536 17.7562 52.9719 17.7562 52.9719L17.3548 50.1769V50.1702Z",
    fill: "#0F1120"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9391 56.0046C25.9391 56.0046 26.497 55.7231 28.5109 55.0193C30.5315 54.3155 32.0352 54.0005 32.0352 54.0005C32.0352 54.0005 28.8102 56.1722 25.9391 55.9979V56.0046Z",
    fill: "#6C706F"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7231 49.2754L17.5396 50.4082C17.5396 50.4082 21.1863 51.5007 25.4794 51.5007C29.7725 51.5007 33.7187 50.073 33.7187 50.073L34.2357 49.3424C34.2357 49.3424 24.4453 51.427 16.7163 49.2754H16.7231Z",
    fill: "#6C6674"
  }))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2309 42.3659C11.2309 42.3659 7.95839 39.658 7.67264 32.3521C7.67264 32.3521 7.80191 36.6083 11.2309 42.3659Z",
    fill: "#5C6160"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4611 17.0396L45.7741 22.8106C45.7741 22.8106 46.4272 18.6147 45.4611 17.0396Z",
    fill: "#575C5B"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M5.43429 17.0396L5.12132 22.8106C5.12132 22.8106 4.16881 18.1991 5.43429 17.0396Z",
    fill: "#575C5B"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M2.55597 30.941C2.55597 30.941 3.20232 30.9141 3.42003 30.7935C3.63095 30.6728 4.02556 30.1567 4.02556 30.1567L2.55597 30.941Z",
    fill: "#686C6C"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9712 30.2402C46.9712 30.2402 47.6923 30.4078 47.7672 30.4748C47.842 30.5419 48.3387 30.9306 48.3387 30.9306C48.3387 30.9306 47.3113 30.6022 46.9712 30.2402Z",
    fill: "#686C6C"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3441 47.8411C32.3441 47.8411 34.4192 46.085 35.3377 45.7298C36.263 45.3745 36.644 45.0796 36.644 45.0796C36.644 45.0796 35.5078 47.1842 32.3373 47.8411H32.3441Z",
    fill: "#686C6C"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1364 17.0645C16.1364 17.0645 19.4225 14.8325 24.8518 14.5309C24.8518 14.5309 21.0758 13.5791 16.1364 17.0645Z",
    fill: "#585D5C"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M7.88868 27.8457C7.32398 27.8658 6.95658 29.0857 7.60293 29.7761C8.24247 30.4597 9.16777 27.8055 7.88868 27.8457Z",
    fill: "#0F1120"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33105 28.8115C7.48754 29.4215 8.26315 29.2003 8.45366 28.7914C8.63736 28.3826 8.38562 27.6788 7.82092 27.8597C7.24941 28.034 7.33786 28.8115 7.33786 28.8115H7.33105Z",
    fill: "#BAA1BE"
  }))), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M7.35205 29.375C7.39287 28.9595 7.99159 29.2477 8.27735 29.1806C8.5563 29.1069 8.29095 29.8509 7.94397 29.871C7.59698 29.8911 7.35885 29.375 7.35885 29.375H7.35205Z",
    fill: "#5C6160"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4074 21.1648L13.2579 21.5804C13.2579 21.5804 17.8776 16.2986 24.8581 16.2986C31.8387 16.2986 36.4583 21.0643 36.4583 21.0643L37.5401 20.3739C37.5401 20.3739 33.0429 15.0854 24.8581 15.0854C16.6733 15.0854 12.4006 21.1581 12.4006 21.1581L12.4074 21.1648Z",
    fill: "url(#paint21_linear_4655_315331)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7349 20.7523L13.2656 21.1612C13.2656 21.1612 18.0826 16.0671 24.9815 16.0671C31.8804 16.0671 36.364 20.5579 36.364 20.5579L37.262 20.0686C37.262 20.0686 32.9349 15.1689 24.9951 15.1689C17.0552 15.1689 12.7281 20.7523 12.7281 20.7523H12.7349Z",
    fill: "url(#paint22_linear_4655_315331)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3535 44.4084C10.3535 44.4084 10.9522 42.8534 11.2312 42.5383C11.5101 42.2233 13.7009 41.7206 13.7009 41.7206C13.7009 41.7206 12.6871 41.7809 12.3742 41.915C12.0544 42.049 10.8365 41.4257 10.6324 41.4458C10.4283 41.4659 10.3603 44.4084 10.3603 44.4084H10.3535Z",
    fill: "#0F1120"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M10.911 43.0795C10.911 43.0795 11.3464 42.8114 11.4281 42.7645C11.5097 42.7242 12.333 42.0674 12.333 42.0674C12.333 42.0674 11.4281 42.188 11.1968 42.2819C10.9722 42.369 10.9042 43.0795 10.9042 43.0795H10.911Z",
    fill: "#4F5554"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4077 44.0384C10.4077 44.0384 11.0677 42.4231 11.2038 42.289C11.3398 42.1549 11.4895 41.8734 11.4895 41.8734C11.4895 41.8734 10.7411 41.4042 10.6254 41.4377C10.5098 41.4713 10.3669 43.4486 10.4077 44.0384Z",
    fill: "#6C6674"
  }))), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1356 42.295C11.1356 42.295 11.4281 42.5564 11.5438 42.5765C11.6595 42.5966 11.9792 42.1274 11.9792 42.1274C11.9792 42.1274 11.435 42.1811 11.1356 42.295Z",
    fill: "#666A69"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2569 41.9315C12.2569 41.9315 12.3386 42.0321 12.5427 42.0187C12.74 42.0053 13.4884 41.7707 13.4884 41.7707C13.4884 41.7707 12.8897 41.7506 12.2637 41.9315H12.2569Z",
    fill: "#6C6674"
  }))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7329 41.462C10.7329 41.462 10.0525 40.537 9.95045 40.5169C9.8552 40.4968 10.5288 41.5759 10.5288 41.5759L10.7261 41.462H10.7329Z",
    fill: "#7B7E7D"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9341 14.7827C11.9341 14.7827 10.9612 14.1124 9.61408 15.0776C8.26695 16.0428 8.55951 18.8446 8.55951 18.8446C8.55951 18.8446 9.34873 19.7025 10.8319 17.7386C12.3151 15.7747 11.9409 14.7827 11.9409 14.7827H11.9341Z",
    fill: "url(#paint23_linear_4655_315331)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M8.81814 18.8105C8.25344 18.4553 8.90659 16.7796 10.798 15.982C12.6894 15.1777 10.8592 17.966 9.96115 18.5223C9.06307 19.0787 8.81814 18.8105 8.81814 18.8105Z",
    fill: "#CEFFD3"
  }))), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8255 15.2382C10.6418 15.6069 11.0637 15.5734 11.1861 15.3321C11.3086 15.0908 10.8868 15.1109 10.8255 15.2382Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M8.52542 18.2807C8.52542 18.2807 8.55944 16.3235 9.70926 15.3851C10.8591 14.4467 11.6959 14.6679 11.6959 14.6679C11.6959 14.6679 10.6958 14.192 9.47793 15.2041C8.39615 16.1023 8.53222 18.2807 8.53222 18.2807H8.52542Z",
    fill: "#6C6674"
  }))), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0576 14.7827C39.0576 14.7827 40.0305 14.1124 41.3777 15.0776C42.7248 16.0428 42.4322 18.8446 42.4322 18.8446C42.4322 18.8446 41.643 19.7025 40.1598 17.7386C38.6766 15.7747 39.0508 14.7827 39.0508 14.7827H39.0576Z",
    fill: "url(#paint24_linear_4655_315331)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1741 18.8105C42.7388 18.4553 42.0856 16.7796 40.1942 15.982C38.3028 15.1777 40.133 17.966 41.0311 18.5223C41.9291 19.0854 42.1741 18.8105 42.1741 18.8105Z",
    fill: "#CEFFD3"
  }))), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1666 15.2382C40.3503 15.6069 39.9284 15.5734 39.806 15.3321C39.6835 15.0908 40.1053 15.1109 40.1666 15.2382Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4666 18.2807C42.4666 18.2807 42.4326 16.3235 41.2828 15.3851C40.133 14.4467 39.2961 14.6679 39.2961 14.6679C39.2961 14.6679 40.2963 14.192 41.5141 15.2041C42.5959 16.1023 42.4598 18.2807 42.4598 18.2807H42.4666Z",
    fill: "#6C6674"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M43.2503 34.3148C44.5906 32.2839 46.6589 31.2718 47.8836 32.056C49.1083 32.8402 49.013 35.1192 47.6727 37.1434C46.3324 39.1743 44.2641 40.1864 43.0394 39.4022C41.8147 38.618 41.91 36.3391 43.2503 34.3148Z",
    fill: "url(#paint25_radial_4655_315331)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M30.6514 9.87756C31.9917 7.84664 34.8969 7.37074 37.1489 8.81183C39.4009 10.2529 40.1425 13.0681 38.809 15.099C37.4755 17.1299 34.5635 17.6058 32.3115 16.1647C30.0595 14.7236 29.3179 11.9085 30.6514 9.88426V9.87756Z",
    fill: "url(#paint26_radial_4655_315331)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M11.735 16.2499C10.1974 14.3598 10.8438 11.3368 13.1774 9.49359C15.5111 7.65034 18.6475 7.69056 20.1784 9.58073C21.716 11.4709 21.0696 14.4938 18.736 16.3371C16.4023 18.1803 13.2659 18.1401 11.735 16.2499Z",
    fill: "url(#paint27_radial_4655_315331)"
  }), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2446 37.3002H19V24.7695H21.2446V37.3002Z",
    fill: "#E8F1FF"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6574 24.7695L29.6172 37.3002H27.3165L23.2575 24.7695H25.7266L27.6532 31.0717L28.5323 34.3149L29.4676 31.0533L31.3754 24.7695H33.6574Z",
    fill: "#E8F1FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4655_315331",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.9966 29.5091) scale(24.9966 24.6258)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "transparent",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#54CCF9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#3E97B8",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#2B6980",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1B4352",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "transparent",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4655_315331",
    x1: 18.8875,
    y1: 18.1786,
    x2: 18.8875,
    y2: 0.0141602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#212225"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4655_315331",
    x1: 18.8612,
    y1: 15.0485,
    x2: 18.8612,
    y2: 2.35352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F5051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151619"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4655_315331",
    x1: 32.0013,
    y1: 18.1786,
    x2: 32.0013,
    y2: 0.0141602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#212225"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4655_315331",
    x1: 32.027,
    y1: 15.0485,
    x2: 32.027,
    y2: 2.35352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F5051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151619"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4655_315331",
    x1: 25.3087,
    y1: 51.2296,
    x2: 25.3087,
    y2: 12.5884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#121527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4655_315331",
    x1: 25.3077,
    y1: 49.2778,
    x2: 25.3077,
    y2: 14.5376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F5051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151619"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4655_315331",
    x1: 13.6257,
    y1: 27.2223,
    x2: 13.6257,
    y2: 4.52015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#212225"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4655_315331",
    x1: 16.1703,
    y1: 18.332,
    x2: 16.1703,
    y2: 6.34082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1A3AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3B3D3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151619"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4655_315331",
    x1: 16.1344,
    y1: 16.8458,
    x2: 16.1344,
    y2: 6.97936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4655_315331",
    x1: 5.972,
    y1: 42.373,
    x2: 5.972,
    y2: 22.8145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#212225"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4655_315331",
    x1: 5.72517,
    y1: 40.3175,
    x2: 5.72517,
    y2: 24.9616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1A3AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3B3D3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151619"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4655_315331",
    x1: 5.53507,
    y1: 39.4536,
    x2: 5.53507,
    y2: 26.9798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4655_315331",
    x1: 37.2635,
    y1: 27.2218,
    x2: 37.2635,
    y2: 4.51967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#212225"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4655_315331",
    x1: 34.7238,
    y1: 18.3325,
    x2: 34.7238,
    y2: 6.34131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1A3AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3B3D3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151619"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4655_315331",
    x1: 34.7528,
    y1: 16.8458,
    x2: 34.7528,
    y2: 6.97936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4655_315331",
    x1: 44.9234,
    y1: 42.373,
    x2: 44.9234,
    y2: 22.8145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#212225"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4655_315331",
    x1: 45.1627,
    y1: 40.317,
    x2: 45.1627,
    y2: 24.9611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1A3AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3B3D3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151619"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4655_315331",
    x1: 45.3594,
    y1: 39.4536,
    x2: 45.3594,
    y2: 26.9798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4655_315331",
    x1: 25.3974,
    y1: 57.0117,
    x2: 25.3974,
    y2: 47.6279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#212225"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_4655_315331",
    x1: 25.4794,
    y1: 56.0116,
    x2: 25.4794,
    y2: 49.2754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F5051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151619"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_4655_315331",
    x1: 24.9806,
    y1: 21.5804,
    x2: 24.9806,
    y2: 15.0922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1A3AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3B3D3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151619"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_4655_315331",
    x1: 24.9951,
    y1: 21.1612,
    x2: 24.9951,
    y2: 15.1756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_4655_315331",
    x1: 10.1852,
    y1: 19.0607,
    x2: 10.3075,
    y2: 14.5313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_4655_315331",
    x1: 40.8117,
    y1: 19.0601,
    x2: 40.6894,
    y2: 14.5306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8D6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_4655_315331",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.2437 35.0085) rotate(-147.41) scale(2.63261 4.39179)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91FFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#8EF9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#68B8AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#488079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#2E524D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#1A2E2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#0B1413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#030505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_4655_315331",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.4141 11.0947) rotate(-147.41) scale(4.84212 4.39179)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91FFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#8EF9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#68B8AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#488079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#2E524D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#1A2E2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#0B1413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#030505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_4655_315331",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.5006 11.7615) rotate(141.717) scale(5.37517 4.39798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91FFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#8EF9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#68B8AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#488079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#2E524D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#1A2E2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#0B1413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#030505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4655_315331"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 57,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatinumLeague);
export default __webpack_public_path__ + "static/media/platinum-league.2b7f1de72d8638056f7a5abe96f66351.svg";
export { ForwardRef as ReactComponent };